import React, { useEffect, } from 'react';
import { pipe, } from 'ramda';
import { connect, } from 'react-redux';
import Box from '@material-ui/core/Box';
import { useLocation, useHistory, } from 'react-router-dom';

import { StoreBasicDataApiStructure, } from 'common/types';
import { repositories, } from 'api';
import { ProductsItem, } from './components/Item';
import ProductLoaderSkeleton from './components/ProductLoaderSkeleton';
import { shopCartOperations } from 'store/ducks/shopCart';
import { useInitFetchProducts } from './hooks';
import { getInfoAboutAllowingRequestBasedOnValidLogin } from 'common/selectors';

type Props = StoreBasicDataApiStructure<repositories.products.CollectionTypes.ProductsType> & {
    fetchCart: Function,
    allowRequest: boolean,
};

const transformLabels = ({ name, }: repositories.products.CollectionTypes.ProductsLabelType) => name;

const renderProduct = ({
    code,
    name,
    images,
    type,
    attributes,
    availability,
    price,
    labels,
    shortDescription,
    slug,
    minQuantity,
    taxAmount,
}: repositories.products.CollectionTypes.ProductsItemType) => (
    <Box key={code}
         my={2}>
        <ProductsItem code={code}
                      slug={slug}
                      name={name}
                      taxAmount={taxAmount}
                      availability={availability}
                      images={images}
                      type={type}
                      attributes={attributes}
                      price={price.current}
                      labels={labels.map(transformLabels)}
                      shortDescription={shortDescription}
                      minQuantity={minQuantity}
        />
    </Box>
);

const ProductsList: React.FC<Props> = ({
    fetchCart,
    data,
    isLoading,
    allowRequest,
}) => {
    const location = useLocation();
    const history = useHistory();
    const fetchProducts = useInitFetchProducts();

    useEffect(
        () => {
            fetchCart();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    useEffect(() => {
        if (history.action === 'PUSH') {
            allowRequest && fetchProducts(location.search);
            return;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ allowRequest, ]);

    useEffect(() => {
        if (history.action === 'PUSH') {
            return;
        }

        allowRequest && fetchProducts(location.search);
    }, [ location.search, history.action, allowRequest, ]);

    return isLoading
        ? (<ProductLoaderSkeleton />)
        : (<>{data?.items.map(renderProduct)}</>);
};

type MappingType = {
    products: {
        collection: StoreBasicDataApiStructure<repositories.products.CollectionTypes.ProductsType>,
    },
    me: StoreBasicDataApiStructure<repositories.MeType>,
};

const mapStateToProps = ({ products, me, }: MappingType) => ({
    allowRequest: getInfoAboutAllowingRequestBasedOnValidLogin(me),
    ...products.collection,
});
const mapDispatchToProps = {
    fetchCart: shopCartOperations.fetchCart.request,
};

export default pipe<React.FC<Props>, React.FC>(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ProductsList);
